import { Paragraph, Table, TableRow, TableCell } from "docx";
import { formatFloats } from "./published-model-helpers";

export const formatNeedRange = (dimension, index, array) => {
  const [min, max] = dimension;

  // Special case for [0, 0] - Non-Aid Applicant
  if (min === 0 && max === 0) {
    return "$0 Need";
  }

  // Last range gets a "+"
  if (index === array.length - 1) {
    return `${formatFloats(min, "currency")}+`;
  }

  // Regular range
  return `${formatFloats(min, "currency")} - ${formatFloats(max, "currency")}`;
};

export const createNeedRankTable = (xdimensions) => {
  // Create header row
  const needRankNonAidRow = new TableRow({
    children: [
      new TableCell({
        children: [new Paragraph("Non-Aid Applicant")],
      }),
      new TableCell({
        children: [new Paragraph("1")],
      }),
    ],
  });

  // Create header row
  const needRankHeaderRow = new TableRow({
    children: [
      new TableCell({
        children: [new Paragraph("Financial Need Range")],
      }),
      new TableCell({
        children: [new Paragraph("Need Rank")],
      }),
    ],
  });

  // Create data rows from xdimensions
  const needRankDataRows = xdimensions.map(
    (dimension, index) =>
      new TableRow({
        children: [
          new TableCell({
            children: [
              new Paragraph(formatNeedRange(dimension, index, xdimensions)),
            ],
          }),
          new TableCell({
            children: [new Paragraph((index + 2).toString())], // Need Rank starts at 1
          }),
        ],
      })
  );

  return new Table({
    rows: [needRankHeaderRow, needRankNonAidRow, ...needRankDataRows],
  });
};

export const getUniqueFunds = (specialFunds) => {
  const uniqueFunds = [];
  specialFunds.forEach((fund) => {
    if (!uniqueFunds.some((f) => f === fund.fundName)) {
      uniqueFunds.push(fund.fundName);
    }
  });
  return uniqueFunds;
};

export const createSpecialFundsList = (specialFunds) => {
  return specialFunds.map((fund) => {
    return new Paragraph({
      text: fund,
      bullet: {
        level: 0,
      },
    });
  });
};

export const getCurrentDate = () => {
  return new Date().toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};
